define("shared/components/shared/restricted-area/modal", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Ui::ModalWithOverlay @overlayClass={{@feature.overlayClass}} @title={{@feature.title}}>
    <Shared::RestrictedArea::Body
      @actionMethod={{@actionMethod}}
      @actionText={{@actionText}}
      @additionalButtonText={{@additionalButtonText}}
      @feature={{@feature}}
      @isDisabled={{@isDisabled}}
      @seamlessCheckoutSuccessCallback={{@seamlessCheckoutSuccessCallback}}
    />
  </Shared::Ui::ModalWithOverlay>
  */
  {
    "id": "9GuPaq+G",
    "block": "[[[8,[39,0],null,[[\"@overlayClass\",\"@title\"],[[30,1,[\"overlayClass\"]],[30,1,[\"title\"]]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[39,1],null,[[\"@actionMethod\",\"@actionText\",\"@additionalButtonText\",\"@feature\",\"@isDisabled\",\"@seamlessCheckoutSuccessCallback\"],[[30,2],[30,3],[30,4],[30,1],[30,5],[30,6]]],null],[1,\"\\n\"]],[]]]]]],[\"@feature\",\"@actionMethod\",\"@actionText\",\"@additionalButtonText\",\"@isDisabled\",\"@seamlessCheckoutSuccessCallback\"],false,[\"shared/ui/modal-with-overlay\",\"shared/restricted-area/body\"]]",
    "moduleName": "shared/components/shared/restricted-area/modal.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});